import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { ServiceFeedbackPage } from "@/features/my/feedback/detail";

export const Route = createFileRoute(
  "/(member)/(protected)/my/feedback/$feedbackId",
)({
  component: ServiceFeedbackPage,
  validateSearch: z.object({
    rating: z.string().optional(),
  }),
});
